<template>
  <div class="text-center">
    <p>Filtrar por estado</p>
    <div class="form-inline form-group d-flex justify-content-center">
      <select
        class="form-control mx-1"
        @change="handleChangeSelect"
        v-model="state"
      >
        <option value="1">Activo ({{counts.active}})</option>
        <option value="0">En espera ({{counts.onHold}})</option>
        <option value="2">Cancelados ({{counts.cancel}})</option>
        <option value="3">Eliminado por el vendedor ({{counts.deleteOwner}})</option>
        <option value="4">Pausado por el vendedor ({{counts.inactive}})</option>
      </select>
    </div>
  </div>
</template>
<script>
import Api from "../../../tools/Api2";

export default {
  name: "FilterState",
  data() {
    return {
      state: 0,
      counts: {
        active: 0,
        onHold: 0,
        cancel: 0,
        inactive: 0,
        deleteOwner: 0
      },
    };
  },
  created: function () {
    Api("count").get("dashboard").then(res => {
            this.counts =
        this.$parent.typePublication == "product"
          ? {
              active: res.products.active,
              onHold: res.products.onHold,
              deleteOwner: res.products.deleteOwner,
              cancel: res.products.cancel,
              inactive: res.products.inactive,
            }
          : {
              active: res.services.active,
              onHold: res.services.onHold,
              deleteOwner: res.services.deleteOwner,
              cancel: res.services.cancel,
              inactive: res.services.inactive
            };
    })
  },
  methods: {
  handleChangeSelect(){
    this.$parent.handleState(this.state);
  }
  },
};
</script>

<style>
</style>